import { render, staticRenderFns } from "./depositCreate.vue?vue&type=template&id=60548f1c&scoped=true&lang=html"
import script from "./depositCreate.vue?vue&type=script&lang=js"
export * from "./depositCreate.vue?vue&type=script&lang=js"
import style0 from "./depositCreate.vue?vue&type=style&index=0&id=60548f1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60548f1c",
  null
  
)

export default component.exports